
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/it-report/survey",
      function () {
        return require("private-next-pages/it-report/survey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/it-report/survey"])
      });
    }
  